import { PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';

import { OfficeHomePageErrorHandler } from '../error-handler/error-handler.service';
import { InstrumentationService, KnownInstrumentationEvents } from '../shared/instrumentation/instrumentation.service';
import { FetchStrategy, InstrumentedHttp, InstrumentedHttpPromise } from '../shared/instrumentation/instrumented-http.service';
import { HttpRequestOptions } from '../shared/models/http-request-options.model';
import { AccessTokenConsumer, AccessTokenService } from '../shared/services/access-token.service';
import { OfficeHomeApiConfigService } from '../shared/services/officehome-api-config.service';
import { SchedulerService } from '../shared/services/scheduler.service';
import { XhrService } from '../shared/services/xhr.service';
import { ContextService } from '../shared/shared-context/context.service';

@Injectable({
    providedIn: 'root'
})

export class SearchInstrumentedXhrService extends XhrService {

    constructor(
        accessTokenService: AccessTokenService,
        contextService: ContextService,
        instrumentedHttp: InstrumentedHttp,
        instrumentationService: InstrumentationService,
        officeHomeApiConfigService: OfficeHomeApiConfigService,
        platformLocation: PlatformLocation,
        private readonly globalErrorHandler: OfficeHomePageErrorHandler,
        scheduler: SchedulerService
    ) {
        super(accessTokenService, instrumentationService, instrumentedHttp, AccessTokenConsumer.None, contextService, officeHomeApiConfigService, platformLocation, scheduler);
    }

    public sendIntrumentedGetRequest(
        eventName: KnownInstrumentationEvents,
        url: string,
        requestConfig: HttpRequestOptions
    ): Promise<Object> {
        return new Promise<Object>((resolve, reject) => {
            this.get<Object>(
                eventName,
                url,
                (promise: InstrumentedHttpPromise<Array<Object>>) => {
                    promise
                        .then(result => {
                            if (result) {
                                resolve(result.data);
                            } else {
                                reject();
                            }
                        })
                        .catch(error => this.globalErrorHandler.handleError(error));
                },
                error => reject(`Failed to get search suggestions. Status Code: ${(error && error.httpResponse) ? error.httpResponse.status : ''}`),
                requestConfig,
                FetchStrategy.NetworkFirst
            );
        });
    }

    public sendIntrumentedPostRequest(
        eventName: KnownInstrumentationEvents,
        url: string,
        data: any,
        requestConfig: HttpRequestOptions
    ): Promise<Object> {
        return new Promise<Object>((resolve, reject) => {
            this.post<Object>(
                eventName,
                url,
                data,
                (promise: InstrumentedHttpPromise<Array<Object>>) => {
                    promise
                        .then(result => {
                            if (result) {
                                resolve(result.data);
                            } else {
                                reject();
                            }
                        })
                        .catch(error => this.globalErrorHandler.handleError(error));
                },
                error => reject(`Failed to get search suggestions. Status Code: ${(error && error.httpResponse) ? error.httpResponse.status : ''}`),
                requestConfig
            );
        });
    }
}
